import { gql } from './apollo';

export const GET_ORDERS_FOR_ACCOUNT = gql`
    query (
        $accountid: MultiTypeInput!
        $offset: Int = 0
        $limit: Int = 10
        $orderBy: String = "effectivedate"
        $orderByDirection: GraphQLDirection = DESC
    ) {
        table(
            name: "order"
            contain: [
                { table: "contact", fk: "sfid", joinFk: "contact__c" }
                {
                    table: "orderitem"
                    fk: "orderid"
                    joinFk: "sfid"
                    or_: [
                        {
                            table: "orderitem"
                            fk: "order__external_id__c"
                            joinFk: "external_id__c"
                        }
                    ]
                }
                { table: "property__c", fk: "sfid", joinFk: "property__c" }
            ]
            filter: [
                { left: "accountid", right: $accountid, expression: "=" }
                { left: "status", right: "Activated", expression: "=" }
                { left: "isdeleted", right: "false", expression: "=" }
            ]
            offset: $offset
            limit: $limit
            orderBy: $orderBy
            orderByDirection: $orderByDirection
        )
    }
`;

export const GET_ORDERITEMS_FOR_ORDERS = gql`
    query ($order_ids: MultiTypeInput!) {
        table(
            name: "orderitem"
            filter: [
                { left: "isdeleted", right: false, expression: "=" }
                { left: "orderid", right: $order_ids, expression: "IN" }
            ]
            limit: 999999
        )
    }
`;

export const GET_ORDERS_FOR_ACCOUNT_BETWEEN_DATES = gql`
    query ($account_id: MultiTypeInput!, $start_date: MultiTypeInput!, $end_date: MultiTypeInput!) {
        table(
            name: "order"

            filter: [
                { left: "accountid", right: $account_id, expression: "=" }
                { left: "status", right: "Activated", expression: "=" }
                { left: "isdeleted", right: "false", expression: "=" }
                { left: "effectivedate", right: $start_date, expression: ">=" }
                { left: "effectivedate", right: $end_date, expression: "<=" }
            ]
            limit: 2000
        )
    }
`;

export const GET_ORDERS_FOR_CONTACT_BETWEEN_DATES = gql`
    query (
        $contact_id: MultiTypeInput!
        $account_id: MultiTypeInput!
        $start_date: MultiTypeInput!
        $end_date: MultiTypeInput!
    ) {
        table(
            name: "order"

            filter: [
                { left: "accountid", right: $account_id, expression: "=" }
                { left: "contact__c", right: $contact_id, expression: "=" }
                { left: "status", right: "Activated", expression: "=" }
                { left: "isdeleted", right: "false", expression: "=" }
                { left: "effectivedate", right: $start_date, expression: ">=" }
                { left: "effectivedate", right: $end_date, expression: "<=" }
            ]
            limit: 2000
        )
    }
`;

export const GET_ORDERS_FOR_CONTACT = gql`
    query (
        $contactid: MultiTypeInput!
        $accountid: MultiTypeInput!
        $offset: Int = 0
        $limit: Int = 10
        $orderBy: String = "effectivedate"
        $orderByDirection: GraphQLDirection = DESC
    ) {
        table(
            name: "order"
            contain: [
                { table: "contact", fk: "sfid", joinFk: "contact__c" }
                {
                    table: "orderitem"
                    fk: "orderid"
                    joinFk: "sfid"
                    or_: [
                        {
                            table: "orderitem"
                            fk: "order__external_id__c"
                            joinFk: "external_id__c"
                        }
                    ]
                }
                { table: "property__c", fk: "sfid", joinFk: "property__c" }
            ]
            filter: [
                { left: "accountid", right: $accountid, expression: "=" }
                { left: "contact__c", right: $contactid, expression: "=" }
                { left: "status", right: "Activated", expression: "=" }
                { left: "isdeleted", right: "false", expression: "=" }
            ]
            offset: $offset
            limit: $limit
            orderBy: $orderBy
            orderByDirection: $orderByDirection
        )
    }
`;

export const GET_ORDER_BY_EXTERNAL_ID = gql`
    query ($external_id__c: MultiTypeInput!) {
        table(
            name: "order"
            filter: [
                { left: "external_id__c", right: $external_id__c, expression: "=" }
                { left: "isdeleted", right: "false", expression: "=" }
            ]
            limit: 1
        )
    }
`;

export const GET_LAST_ORDER_NUMBER = gql`
    query {
        table(
            name: "order"
            filter: [{ left: "ordernumber", right: "null", expression: "!=" }]
            orderBy: "ordernumber"
            orderByDirection: DESC
            limit: 1
        )
    }
`;

export const CREATE_ORDER = gql`
    mutation (
        $totalamount: MultiTypeInput
        $contact__c: MultiTypeInput
        $propertyuser__c: MultiTypeInput
        $property__c: MultiTypeInput
        $external_id__c: MultiTypeInput
        $accountid: MultiTypeInput
        $sfid: MultiTypeInput
        $createddate: MultiTypeInput
        $effectivedate: MultiTypeInput
        $ordernumber: MultiTypeInput
    ) {
        createRow(
            table: "order"
            values: [
                { property: "totalamount", value: $totalamount }
                { property: "contact__c", value: $contact__c }
                { property: "propertyuser__c", value: $propertyuser__c }
                { property: "accountid", value: $accountid }
                { property: "property__c", value: $property__c }
                { property: "ordernumber", value: $ordernumber }
                { property: "external_id__c", value: $external_id__c }
                { property: "sfid", value: $sfid }
                { property: "effectivedate", value: $effectivedate }
                { property: "createddate", value: $createddate }
                { property: "systemmodstamp", value: $createddate }
                { property: "isdeleted", value: false }
                { property: "status", value: "Draft" }
            ]
        )
    }
`;

export const GET_ORDERS_BY_CAMPAIGN_ID = gql`
    query ($campaignid: MultiTypeInput!) {
        table(
            name: "order"
            filter: [
                { left: "campaign__c", right: $campaignid, expression: "=" }
                { left: "isdeleted", right: "false", expression: "=" }
            ]
        )
    }
`;

export const DELETE_ORDER = gql`
    mutation ($id: String!) {
        deleteRow(table: "order", id: $id)
    }
`;
